import { gql } from "@apollo/client";

export const SEND_HELP = gql`
  mutation CreateHelper($input: InputHelper!) {
    CreateHelper(input: $input)
  }
`;
